import Flickity from 'flickity'; // https://flickity.metafizzy.co/
import 'flickity-sync'; // https://github.com/metafizzy/flickity-sync

// Flickity marks off-screen cells aria-hidden but leaves their links and buttons
// focusable, so keyboard users tab into content that is hidden from screen readers
// (axe aria-hidden-focus, WCAG 4.1.2). Keep every hidden cell inert as well.
function syncHiddenCells(slider) {
	slider.cells.forEach((cell) => {
		cell.element.inert = cell.element.getAttribute('aria-hidden') === 'true';
	});
}

function guardHiddenCells() {
	document.querySelectorAll('.flickity-nav, .flickity-content').forEach((element) => {
		const slider = Flickity.data(element);
		if (!slider || slider.__amtInert) return;
		slider.__amtInert = true;
		syncHiddenCells(slider);
		['select', 'settle', 'resize'].forEach((name) => slider.on(name, () => syncHiddenCells(slider)));
	});
}

// The content slider initialises itself from its data-flickity attribute on load.
window.addEventListener('load', guardHiddenCells);

window.addEventListener('DOMContentLoaded', (event) => {
	const flickitySelector = '.flickity-nav';
	const flickity = document.querySelector(flickitySelector);
	let side = '';

	if (document.body.contains(flickity)) {
		// add hover class of left/right
		flickity.addEventListener('mousemove', function (event) {
			side =
				event.pageX - this.offsetLeft < flickity.offsetWidth / 2
					? 'left'
					: 'right';
			flickity.dataset.side = side;
		});

		// init flickity slider
		const flkty = new Flickity(flickitySelector);
		guardHiddenCells();

		// on flickity change - update route
		flkty.on('change', function (index) {
			let slide = this.selectedElement.id;
			let trimPath = window.location.pathname.replace(/\//g, '');

			if (slide !== trimPath) {
				history.pushState({}, '', '/' + slide);
			}
		});

		// watch page route state change
		window.onpopstate = function (event) {
			let trimPath = window.location.pathname.replace(/\//g, '');
			let index = flkty.cells.findIndex(
				(cell) => cell.element.id == trimPath
			);
			flkty.select(index);
		};
	}
});
